module.exports = __webpack_public_path__ + "media/images/official/top_mv2_pc-d41f071dd5e7f3a9e66bf9e3183c3fc1.jpg";